import React, { useState, useEffect } from 'react';
import OptionsArray from './options/array'
import OptionsRemote from './options/remote'
import { Col, Label, Input } from 'reactstrap';

const InputSelectField = ({
    name,
    label,
    required,
    options,
    remote,
    placeholder,
    sizeSm,
    sizeMd,
    sizeLg,
    _handleChange,
    value,
    valueInOptionText,
    selectFirstIfOnlyOne,
}) => {
    sizeSm = !!sizeSm ? sizeSm : 0;
    sizeMd = !!sizeMd ? sizeMd : 0;
    sizeLg = !!sizeLg ? sizeLg : 0;

    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const onFetchOptions = (options) => {
        if (!options || !options.length) return;
        if (!inputValue && !!selectFirstIfOnlyOne && options.length === 1) {
            const newValue = !!remote.value ? options[0][remote.value] : options[0].value;
            setInputValue(newValue);
            _handleChange(newValue, name);
        }
    };

    return (
        <Col sm={sizeSm} md={sizeMd} lg={sizeLg}>
            <Label>{label}</Label>
            <Input
                type="select"
                className="form-control"
                required={required}
                onChange={_handleChange}
                name={name}
                value={inputValue}
            >
                <option value="">{placeholder || "Selecione um item"}</option>

                {
                    remote ?
                        <OptionsRemote
                            service={remote.service}
                            method={remote.method}
                            path={remote.path}
                            params={remote.params}
                            display={remote.display}
                            value={remote.value}
                            onFetchOptions={onFetchOptions}
                        />
                        :
                        <OptionsArray
                            options={options}
                            valueInOptionText={valueInOptionText} />
                }
            </Input>
        </Col>
    )
};

export default InputSelectField;